import React, { FunctionComponent, useState, useEffect } from 'react';
import { useGetBackofficeCitiesQuery } from 'services/exploreApi';
import { navigateTop } from 'common/utils/index';
import Index from '../Index';
import SearchBar from '../SearchBar';

interface Pagination {
  pages: number;
  current: number;
  total: number;
}

const defaultPage: Pagination = {
  pages: 0,
  current: 0,
  total: 0,
};

const Cities: FunctionComponent = () => {
  const [searchFilters, setSearchFilters] = useState<{ [k: string]: any }>({});
  const [pagination, setPagination] = useState<Pagination>(defaultPage);

  const { data: cities, isLoading: citiesLoading } = useGetBackofficeCitiesQuery({
    ...searchFilters,
    page: pagination.current,
  });

  const onFilterChange = (key: string, value: any) => {
    if (value === undefined || value === null || value === '') {
      setSearchFilters(({ [key]: _, ...rest }) => rest);
    } else {
      setSearchFilters((sf) => ({ ...sf, [key]: value }));
    }
  };

  const onFilterTextInputChange = (key: string) => (event: React.ChangeEvent<HTMLInputElement>) => {
    event.target.value = event.target.value.trimStart();
    onFilterChange(key, event.target.value);
  };

  const changePageCities = (page: number) => {
    setPagination((pp) => ({ ...pp, current: page }));
    navigateTop();
  };

  useEffect(() => {
    if (cities?.meta) setPagination(cities.meta);
  }, [cities]);

  const columns = ['Name', 'Country'];
  return (
    <div>
      <SearchBar
        searchFilters={searchFilters}
        onFilterTextInputChange={onFilterTextInputChange}
        name="Search for cities..."
      />
      <Index
        objects={cities?.data}
        isLoading={citiesLoading}
        pagination={{ ...pagination, onChange: changePageCities }}
        columns={columns}
      />
    </div>
  );
};

export default Cities;
